import { Component, forwardRef } from "@angular/core";
import { AsComponent } from "../as.component";
import { Renderer2, ElementRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AsConfigService } from "../asConfig.service";
import { AsInputAbstract } from "./asInput.abstract";
import { AsBoxFilterAbstract } from "../asFilter.abstract";
import { Subject } from "rxjs";
import { AsInputComponent } from "../asInput.component";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { AsInputWithOperatorsComponent } from "../asInputWithOperators.component";

@Component({
    selector:'as-simple-input-with-operators-mask',
    template: `<input type="text"
            [(ngModel)]="filter.viewModel.value.value"
            (change)="_onChange(this.filter.viewModel.value);filter.onChange()"
            (focus)="filter.focusInput$.next()"
            (keydown)="advancedSearchBox.keydown($event,filter.viewModel)" 
            autosize 
            [placeholder]="filter.viewModel.placeholder | translate"
            [mask]="filter.viewModel.mask.mask"
            [specialCharacters]="filter.viewModel.mask.specialCharacters"
            [patterns]="filter.viewModel.mask.patterns"
            [dropSpecialCharacters]="filter.viewModel.mask.dropSpecialCharacters"
            [clearIfNotMatch]="filter.viewModel.mask.clearIfNotMatch"
            [allowNegativeNumbers]="filter.viewModel.mask.allowNegativeNumbers"
            [thousandSeparator]="filter.viewModel.mask.thousandSeparator"
            [maxLength]='maxLength'
            #inputRef
            class="as-text-input"
            />`,
    styles:[`
        input{
            height:100%;
        }
    `],
    providers:[
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AsSimpleInputWithOperatorsMaskComponent),
            multi: true
        }
    ]
    
})
export class AsSimpleInputWithOperatorsMaskComponent extends AsInputAbstract{
    
    maxLength: number;

    constructor(
        public advancedSearchBox: AsComponent,
        protected _http: HttpClient,
        protected _config: AsConfigService,
        public _element: ElementRef,
        public filter:AsInputWithOperatorsComponent
    ) {
        super(advancedSearchBox, _http, _config, _element);
        if (this.filter.viewModel.mask.specialCharacters === undefined) {
            this.filter.viewModel.mask.specialCharacters = ['-', '/', '(', ')', '.', ':', ' ', '+', ',', '@', '[', ']', '"', "'"];
        }

        this.maxLength = 1000;
        if (this.filter.viewModel.dataType === 'currency') {
            this.maxLength = 12;
        } else if(this.filter.viewModel.dataType === 'number') {
            this.maxLength = 10;
        }
    }
}